import React from 'react';
import './App.css';
import { inject, observer } from 'mobx-react';
import { UserProfileUIStore } from './stores/user-profile-ui-store';
import { Image } from 'react-bootstrap';

const defaultLogo = require('./assets/imgs/logo.png');

interface HeaderProps {
  userProfileUIStore?: UserProfileUIStore;
}

@inject('userProfileUIStore')
@observer
export class Header extends React.Component<HeaderProps, {}> {
  componentDidMount() {
    const { userProfileUIStore } = this.props;
    if (userProfileUIStore && !userProfileUIStore.currentUserProfile) {
      userProfileUIStore.loadCurrentUserProfile();
    }
  }

  render() {
    const { userProfileUIStore } = this.props;
    const userProfile = userProfileUIStore?.currentUserProfile;

    // Access logoUpdateTrigger to make component reactive to logo changes
    const logoUpdateTrigger = userProfileUIStore?.logoUpdateTrigger;

    const logoSrc = userProfile?.hasCustomLogo()
      ? userProfile.customLogoUrl
      : defaultLogo;

    return (
      <header className="App-header d-flex justify-content-between align-items-baseline">
        {userProfile && (
          <>
            <Image
              key={`${logoSrc}-${logoUpdateTrigger}`} // Use both URL and trigger for unique key
              src={logoSrc}
              alt="Current Logo"
              fluid
              style={{ maxHeight: '50px', objectFit: 'contain' }}
            />

            {userProfile?.hasCustomLogo() && (
              <div className="d-flex">
                <div className="mr-3">Powered by</div>
                <Image
                  src={defaultLogo}
                  alt="Labsmarts Logo"
                  fluid
                  style={{ maxHeight: '15px', objectFit: 'contain' }}
                />
              </div>
            )}
          </>
        )}
      </header>
    );
  }
}
